import {Object3D, Scene} from "three";
import {Constructor} from "../../util/constructor-wrapper";
import {SceneObjectManagerService} from "../../service/scene-object.manager.service";

/**
 * Provides attribute resolution for implementations of the Insertable feature
 */
interface InsertableMapping<T extends Object3D<any>> {
    _object: T
     data: any
}

/**
 * Interface of the Insertable feature
 */
export interface Insertable {
    insert(scene: Scene): void
}

/**
 * Mixin for the Insertable feature
 * @param base
 */
export function Insertable<Tbase extends Constructor<InsertableMapping<any>>>(base: Tbase): Constructor<Insertable> {
    return class Insertable extends base implements Insertable {
        insert(scene: Scene): void {
            const sceneManager = SceneObjectManagerService.getInstance();

            if(this.data.id === undefined){
                throw new Error("The data object must have an id property");
            }

            sceneManager.addObject(this.data.id, this, scene);
            scene.add(this._object);
        }
    };
}